// extracted by mini-css-extract-plugin
export default {"link":"LinkItem_link__XUBwr","info":"LinkItem_info__D6ztm","name":"LinkItem_name__jj9RH","src":"LinkItem_src__n1gns","imgContainer":"LinkItem_imgContainer__TK7om"};